import { createAbstractAnnouncerIntegration } from 'config/platforms/AbstractAnnouncerIntegration';

// we use a function so createAbstractAnnouncerIntegration only runs when it needs too
export const createTizenAnnouncerIntegration = () =>
  class TizenAnnouncerIntegration extends createAbstractAnnouncerIntegration() {};
